import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';

@autoinject
export class PublicTerms {
	type: string;
	message: string;

	constructor(private i18n: I18N) {

	}

	activate(params, routeConfig) {
		this.type = routeConfig.settings.type || 'SessionStorageError';
		this.getMessage();
	}

	getMessage() {
		switch (this.type) {
			case 'SessionStorageError':
			default:
				this.message = this.i18n.i18next.t('sessionStorageError','A problem occurred when loading this website. Unable to access session storage, please insure your browser is not blocking third party cookies. If the problem persists contact us for assistance.');
		}
	}
}
